class ImageVideoBanner extends HTMLElement {
  constructor() {
    super();
    this.initEvents();

    const video = this.querySelector('.image-banner__media__video');
    if (video) {
      this.initVideo(video);
    }
  }

  initVideo(video) {
    const revealAndPlay = () => {
      video.classList.add('is-loaded');

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    };

    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      revealAndPlay();
      return;
    }

    video.addEventListener('canplay', revealAndPlay, { once: true });
    video.addEventListener('loadeddata', revealAndPlay, { once: true });
    video.load();
  }

  initEvents() {
    function smoothScrollToSection(pElementId, pOffsetPixels) {
      const targetSection = document.getElementById(pElementId);

      if (targetSection) {
        const scrollPosition = targetSection.offsetTop;

        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      }
    }
  }
}

customElements.define('image-video-banner', ImageVideoBanner);
